import React from 'react';
import { motion } from 'framer-motion';
import { SystemStats } from '../types';

interface Props {
  stats: SystemStats;
}

// ═══════════════════════════════════════════════════════════
//  StatsPanel — Auteur Dark editorial metrics
//
//  Numbers render in Instrument Serif. Labels in small-caps
//  mono. Accent is applied as a tiny tick-mark to the left of
//  the number, not as the number colour itself — that way the
//  stats read as a coherent editorial row, with the palette
//  doing semantic work in the margins.
// ═══════════════════════════════════════════════════════════

export const StatsPanel: React.FC<Props> = ({ stats }) => {
  const items = [
    { label: 'Задачи',     value: `${stats.completedTasks}/${stats.totalTasks}`, tick: 'var(--peach)' },
    { label: 'Активные',   value: stats.activeWorkers,                           tick: 'var(--sage)' },
    { label: 'Коммиты',    value: stats.totalCommits,                            tick: 'var(--steel)' },
    { label: 'Тесты OK',   value: stats.testsPassed,                             tick: 'var(--mint)' },
    { label: 'Тесты FAIL', value: stats.testsFailed,                             tick: 'var(--terracotta)' },
    { label: 'Coverage',   value: `${stats.coverage}%`,                          tick: 'var(--amber)' },
  ];

  return (
    <div className="stats-panel">
      {items.map((item, i) => (
        <motion.div
          key={item.label}
          className="stat-card"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: i * 0.06, duration: 0.4, ease: [0.2, 0.8, 0.2, 1] }}
        >
          <div className="stat-tick" style={{ background: item.tick }} />
          <div className="stat-value">{item.value}</div>
          <div className="stat-label">{item.label}</div>
        </motion.div>
      ))}
    </div>
  );
};
